import { displayCurrency } from '../../../../../utils/DisplayCurrency';
import { useCurrentPayLink } from '../../../hooks/useCurrentPayLink';
import { IwocaToBankIllustration } from '../IwocaToBankIllustration/IwocaToBankIllustration';

export const Loading = () => {
  const { payLink } = useCurrentPayLink();

  return (
    <div className="m-auto">
      <div className="text-l font-bold">
        {payLink ? (
          <>
            {payLink?.capture_delay_hours
              ? `Confirming your payment plan...`
              : ` We're making a payment of ${payLink?.amount ? displayCurrency(payLink?.amount) : null} to ${payLink?.seller_trading_name}'s
        bank account...`}
          </>
        ) : (
          'Loading...'
        )}
      </div>
      <IwocaToBankIllustration
        icon={
          <div className="flex-1">
            <span
              className="processing-arrows-vertical block h-[20px] w-[8px] animate-animated-bg-vertical m700:hidden"
              data-ocularid="transfer_arrows_vertical"
            />
            <span
              className="processing-arrows-horizontal hidden h-[15px] w-full animate-animated-bg m700:block"
              data-ocularid="transfer_arrows_horizontal"
            />
          </div>
        }
      />
    </div>
  );
};
